module.exports = __webpack_public_path__ + "static/5628c285-b357-46c1-989b-ae5ec614075b-160.a728b92e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/banjoVase-cinnamon/5628c285-b357-46c1-989b-ae5ec614075b-160.jpg
// module id = 872
// module chunks = 168707334958949